import { i18n } from "@lingui/core";
import { useDealerItemContext } from "../context/DealerItemProviderContext.tsx";

export const ErrorInfo = () => {
  const { status } = useDealerItemContext();

  const title =
    status === "notFound"
      ? i18n.t({
          id: "dealer.fallbackTitle.notFound",
          message: "Dealer information isn't available",
        })
      : i18n.t({ id: "dealer.fallbackTitle", message: "Sorry, something went wrong" });

  const description =
    status !== "notFound"
      ? i18n.t({
          id: "dealer.fallbackDescription",
          message: "Something went wrong when attempting to retrieve the contact details for this ad.",
        })
      : undefined;

  return (
    <>
      <h3>{title}</h3>
      {description && <p className="leading-ml">{description}</p>}
    </>
  );
};
